import { MembershipPlan } from './membership.constants';
import { TRACKING_ID_PARAM } from '../../constants';

export type SupportPlan = MembershipPlan | 'donate' | 'teams';

export type SupportQueryParams = {
  plan?: SupportPlan;
  source?: string;
};

export type MembershipQueryParamKey =
  | keyof typeof MEMBERSHIP_URL_PARAM_KEYS
  | typeof TRACKING_ID_PARAM;

// The intersection with Partial<Record<MembershipQueryParamKey, ...>> adds autocomplete for known param keys.
export type MembershipQueryParams = Record<string, string | null> &
  Partial<Record<MembershipQueryParamKey, string | null>>;

export const MEMBERSHIP_URL_PARAM_KEYS = {
  plan: 'plan',
  source: 'source',
  clientToken: 'clientToken',
  email: 'email',
  verificationToken: 'verificationToken',
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  upgrade: 'upgrade',
  donationSuccess: 'donationSuccess',
  transaction: 'transaction',
  membershipSuccess: 'membershipSuccess',
  membershipUpgrade: 'membershipUpgrade',
} as const;
